import script from "./TankForecastChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TankForecastChart.vue?vue&type=script&setup=true&lang=js"

import "./TankForecastChart.vue?vue&type=style&index=0&id=85302896&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85302896"]])

export default __exports__